export default __webpack_public_path__ + "static/media/BGImgEclipse.42f78184.png";